import React from 'react';

const PhoneCheck: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 46H10C8.93913 46 7.92172 45.5786 7.17157 44.8284C6.42143 44.0783 6 43.0609 6 42V6C6 4.93913 6.42143 3.92172 7.17157 3.17157C7.92172 2.42143 8.93913 2 10 2H34C35.0609 2 36.0783 2.42143 36.8284 3.17157C37.5786 3.92172 38 4.93913 38 6V26"
        stroke="#00A868"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M30 40L34 44L44 34"
        stroke="#00A868"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
};

export default PhoneCheck;
